import React from 'react';
import classNames from 'classnames';
import Link, { LinkProps } from '@material-ui/core/Link';
import makeStyles from '@material-ui/core/styles/makeStyles';

interface Props extends LinkProps {}

function HelpDocLink(props: Props) {
  const classes = useStyles();

  const { color, underline, target, rel, className, ...restOfProps } = props;

  return (
    <Link
      color="secondary"
      underline="always"
      target="_blank"
      rel="noopener noreferrer"
      className={classNames(classes.root, className)}
      {...restOfProps}
    />
  );
}

const useStyles = makeStyles(theme => ({
  root: { ...theme.typography.body1, display: 'block', marginTop: theme.spacing(0.75) },
}));

export default HelpDocLink;
